module.exports = __webpack_public_path__ + "img/ability-swiper4.d55623cc.png";